import { Dialog, Transition, Tab } from "@headlessui/react";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import CelesFloatingInputState from "../components/leasing.c.celesfloatinginputstate";
import {
  getCurrentLocalDateTime,
  pad,
  months,
} from "../../../utils/getLocalDateTime";
import Dropdown from "../components/leasing.c.dropdown";
import classNames from "classnames";
import useDateDropdown from "../hooks/useDateDropdown";
import {
  getAmountReturnCarFee,
  getLastDemandFee,
  getTotalOfPreInstallmentsHalf,
} from "../utils/leasing.u";
import { Radio } from "antd";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { S3Image } from "aws-amplify-react";
import { EmitterStatus } from "../../../event";

const PaymentModal = ({
  open,
  setOpen,
  action,
  loading,
  actionFee,
  actionServiceFee,
  paidDate,
  loan,
  interest,
  filePayment,
  setFilePayment,
  setFilePaymentBase,
  filePaymentBase,
  isSubmit,
  totalCancel,
}) => {
  const today = getCurrentLocalDateTime();

  const {
    onSelectDate,
    onSelectHour,
    onSelectMintue,
    onSelectMonth,
    onSelectYear,
    selectDate,
    selectHour,
    selectMinute,
    selectMonth,
    selectYear,
    optionsDates,
    optionsHours,
    optionsMintues,
    optionsMonths,
    optionsYears,
    setSelectDate,
    setSelectHour,
    setSelectMinute,
    setSelectMonth,
    setSelectYear,
  } = useDateDropdown();

  const confirmPassword = "123456";

  const [serviceFee, setServiceFee] = useState("0"); // จำนวนเงินที่จ่ายค่าธรรมเนียม
  const [amount, setAmount] = useState("0"); // จำนวนเงินที่ชำระในงวด
  const [amountFee, setAmountFee] = useState("0"); //จำนวนเงินค่าธรรมเนียมที่เพิ่ม
  const [feeRemark, setFeeRemark] = useState("-");
  const [priceType, setPriceType] = useState("N");
  const [password, setPassword] = useState("");
  const [discountInterest, setDiscountInterest] = useState("");

  const [type, setType] = useState("demand_fee");

  useEffect(() => {
    clearState();
  }, [loan]);

  useEffect(() => {
    // setAmount(totalCancel);
  }, [totalCancel]);

  const getInitialCategory = () => {
    if (loan?.category === "TF") {
      return {
        ชำระค่างวด: [],
        เพิ่มค่าธรรมเนียม: [],
        ชำระค่าธรรมเนียมอื่นๆ: [],
      };
    }
    return {
      ชำระค่างวด: [],
    };
  };

  let [categories, setCategories] = useState({});

  useEffect(() => {
    setCategories(getInitialCategory());
  }, [loan]);

  function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  useEffect(() => {
    if (isValidDate(new Date(paidDate))) {
      const paidDateFormat = getCurrentLocalDateTime(paidDate);
      setSelectMonth(pad(paidDateFormat.month));
      setSelectDate(pad(paidDateFormat.date));
      setSelectYear(paidDateFormat.year);
    }
  }, [paidDate]);

  useEffect(() => {
    initAmountFee(type);
  }, [type, loan]);

  const optionMap = () => {
    if (type === "demand_fee") {
      return "ค่าท่วงถาม";
    } else if (type === "service_fee") {
      return "ค่าบริการ";
    } else if (type === "visit_fee") {
      return "ค่าลงพื้นที่";
    } else if (type === "break_fee") {
      return "ค่ายกเลิกสัญญา";
    } else if (type === "return_car_fee") {
      return "ค่าคืนยานพาหนะ";
    } else if (type === "other_fee") {
      return "ค่าธรรมเนียมอื่นๆ";
    }
    return "unknown";
  };

  const optionFee = [
    // { label: "ค่าบริการ", value: "service_fee", disabled: false },
    {
      label: "ค่าธรรมเนียมอื่นๆ",
      value: "other_fee",
      disabled: false,
    },
    {
      label: "ค่าทวงถาม",
      value: "demand_fee",
      disabled: false,
    },
    {
      label: "ค่าลงพื้นที่",
      value: "visit_fee",
      disabled: loan?.break_fee > 0,
    },
    {
      label: "ค่ายกเลิกสัญญา",
      value: "break_fee",
      disabled: loan?.break_fee > 0,
    },
    // {
    //   label: "ค่าคืนยานพาหนะ",
    //   value: "return_car_fee",
    //   disabled: loan?.break_fee === 0 || loan?.return_car_fee > 0,
    // },
  ];

  function closeModal() {
    setOpen(false);
    clearState();
  }

  const onActionFee = async () => {
    try {
      if (actionFee !== undefined) {
        await actionFee(amountFee, type, feeRemark, getPaidDate());
        clearState();
      }
    } catch (error) {
      await EmitterStatus("ERROR", { text: "Sometinh went wrong." });
    }
  };

  const onActionServiceFee = async () => {
    try {
      if (serviceFee !== undefined) {
        await actionServiceFee(serviceFee, feeRemark, getPaidDate());
        clearState();
      }
    } catch (error) {
      await EmitterStatus("ERROR", { text: "Sometinh went wrong." });
    }
  };

  const getPaidDate = () => {
    const paid_date = `${selectYear}-${pad(selectMonth)}-${pad(
      selectDate
    )}T${pad(selectHour)}:${pad(selectMinute)}:${pad(today.seconds)}`;
    var date = new Date(paid_date + "+07:00");
    return date;
  };

  const onAction = async () => {
    try {
      if (action !== undefined) {
        await action(amount, getPaidDate(), priceType);
        clearState();
      }
    } catch (error) {
      await EmitterStatus("ERROR", { text: "Sometinh went wrong." });
    }
  };

  const clearState = () => {
    initAmountFee();
    if (Number(totalCancel) === 0) {
      setAmount("0");
    }
    setServiceFee("0");
    setType("demand_fee");
    setFeeRemark("-");
    setPriceType("N");
    setPassword("");
    setFilePayment("");
    setFilePaymentBase("");
  };

  const onChangeType = (e) => {
    const { value } = e.target;
    if (value === "C") {
      const totalPreInstallment = getTotalOfPreInstallmentsHalf(
        loan?.installments,
        getPaidDate(),
        interest.INTEREST_PENALTY_DATE
      );
      setAmount(`${totalPreInstallment.close_total}`);
      setDiscountInterest(`${totalPreInstallment?.discountInterest}`);
    } else {
      setAmount("0");
    }
    setPriceType(value);
  };

  const initAmountFee = (type = "demand_fee") => {
    if (type === "break_fee") {
      setAmountFee(`${interest.BREAK_FEE || 1000}`);
    } else if (type === "return_car_fee") {
      const amountReturnCarFee = getAmountReturnCarFee(
        loan,
        interest.RETURN_CAR,
        paidDate
      );
      setAmountFee("0");
    } else if (type === "visit_fee") {
      setAmountFee(`${interest.VISIT_FEE || 0}`);
    } else if (type === "demand_fee") {
      setAmountFee(`${getLastDemandFee(loan?.installments) || 50}`);
    } else {
      setAmountFee("0");
    }
  };

  const onChangeFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFilePayment(file);
      getBase64(file);
    }
  };

  const onClickOpenFile = () => {
    let docFile = document.createElement("input");
    docFile.type = "file";
    docFile.accept = "image/*";
    docFile.onchange = onChangeFile;
    docFile.click();
  };

  const getBase64 = (file) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setFilePaymentBase(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  const handleApprove = useFullScreenHandle();

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={closeModal}
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-50"
            leave="ease-in duration-200"
            leaveFrom="opacity-50"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-50" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="border border-gray-200 z-50 inline-block w-full max-w-xl p-6 my-8 overflow-visible text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <Dialog.Title
                as="h3"
                className="text-lg font-medium leading-6 text-gray-900"
              >
                คำขอชำระค่างวด
              </Dialog.Title>
              <Tab.Group>
                <Tab.List className="flex p-1 space-x-1 bg-white rounded-xl mt-2">
                  {Object.keys(categories).map((category) => (
                    <Tab
                      key={category}
                      className={({ selected }) =>
                        (selected
                          ? "text-white  bg-sky-500"
                          : "text-sky-500 bg-white") +
                        " w-full py-2 text-sm leading-5 font-medium cursor-pointer rounded-full  focus:outline-none "
                      }
                    >
                      {category}
                    </Tab>
                  ))}
                </Tab.List>
                <Tab.Panels className="mt-2">
                  <Tab.Panel>
                    {" "}
                    <div className="h-2"></div>
                    <div className="w-full mb-4">
                      <div className="bg-black h-52 flex flex-col justify-center">
                        <FullScreen
                          className="w-full h-full"
                          handle={handleApprove}
                        >
                          {filePayment && (
                            <img
                              src={filePaymentBase}
                              onClick={handleApprove.enter}
                              className="w-full h-full object-contain bg-black"
                            />
                          )}
                        </FullScreen>
                      </div>
                      {!filePayment && (
                        <div className="text-red-500 text-xs mt-1">
                          โปรดอัพโหลดรูปภาพ
                        </div>
                      )}
                      <button
                        className={classNames(
                          "bg-blue-500 text-white px-2 py-1 rounded text-sm cursor-pointer mt-2"
                        )}
                        onClick={onClickOpenFile}
                      >
                        เลือกรูปภาพ
                      </button>
                    </div>
                    <CelesFloatingInputState
                      onChange={(e) => setAmount(e.target.value)}
                      label="ยอดเงิน"
                      value={amount}
                      disable={priceType === "C"}
                      // disable={loan?.break_fee > 0 || loan?.return_car_fee > 0}
                    />
                    {loan?.category === "TF" &&
                      loan?.loan_status !== "DONE" && (
                        <div className="flex items-center mt-2 ml-1">
                          <Radio.Group
                            onChange={onChangeType}
                            value={priceType}
                          >
                            {!["CANCEL"].includes(loan?.loan_status) && (
                              <Radio value={"N"}>
                                {loan?.loan_status === "CANCEL"
                                  ? "ชำระยกเลิกสัญญา"
                                  : "ชำระปกติ"}
                              </Radio>
                            )}

                            {["SEIZE"].includes(loan?.loan_status) && (
                              <Radio value={"S"}>ชำระยึดรถ</Radio>
                            )}

                            {!["CANCEL", "SEIZE", "TRANSFER_VEHICLE"].includes(
                              loan?.loan_status
                            ) && <Radio value={"C"}>ชำระปิดสัญญา</Radio>}
                          </Radio.Group>
                          {priceType === "C" && (
                            <div className="flex ml-1">
                              <div>ส่วนลดดอกเบี้ย</div>
                              <div className="text-blue-500 ml-2">
                                {" "}
                                {discountInterest !== "0"
                                  ? Number(discountInterest) * 100
                                  : 100}
                                %
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    {loan?.category === "NTF" &&
                      loan?.loan_status !== "DONE" && (
                        <div className="flex items-center mt-2 ml-1">
                          <Radio.Group
                            onChange={onChangeType}
                            value={priceType}
                          >
                            <Radio value={"N"}>ชำระปกติ</Radio>
                            {["TRANSFER_VEHICLE", "SEIZE"].includes(
                              loan?.loan_status
                            ) && <Radio value={"S"}>ชำระยึดรถ</Radio>}
                          </Radio.Group>
                        </div>
                      )}
                    <div className="w-full text-left text-gray-700 text-sm mt-4">
                      วัน/เวลา ที่ชำระ
                    </div>
                    <div className="flex flex-row w-full space-x-1">
                      <div className="w-24">
                        <Dropdown
                          options={optionsDates}
                          selected={pad(selectDate)}
                          label={"วัน"}
                          setSelected={onSelectDate}
                        />
                      </div>
                      <Dropdown
                        options={optionsMonths}
                        selected={pad(selectMonth)}
                        label={"เดือน"}
                        setSelected={onSelectMonth}
                      />
                      <Dropdown
                        options={optionsYears}
                        selected={pad(selectYear)}
                        label={"ปี"}
                        setSelected={onSelectYear}
                      />
                      <Dropdown
                        options={optionsHours}
                        selected={pad(selectHour)}
                        label={"ชั่วโมง"}
                        setSelected={onSelectHour}
                      />
                      <Dropdown
                        options={optionsMintues}
                        selected={pad(selectMinute)}
                        label={"นาที"}
                        setSelected={onSelectMintue}
                      />
                    </div>
                    <div className="mt-4">
                      {!["CANCEL", "DONE"].includes(loan?.loan_status) &&
                        loan?.category === "TF" && (
                          <button
                            disabled={
                              loading || Number(amount) <= 0 || !filePayment
                            }
                            type="button"
                            className={classNames(
                              "flex items-center justify-center px-8 py-2 text-sm font-medium text-blue-900 border border-transparent rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500",
                              {
                                "cursor-pointer hover:bg-blue-200 bg-blue-100":
                                  !loading && Number(amount) > 0 && filePayment,
                                "cursor-not-allowed bg-gray-300":
                                  loading ||
                                  Number(amount) <= 0 ||
                                  !filePayment,
                              }
                            )}
                            onClick={onAction}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className={
                                (loading ? "" : "hidden") +
                                " animate-spin  h-6 w-6 mr-3"
                              }
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                              />
                            </svg>
                            อนุมัติ
                          </button>
                        )}
                      {loan?.category === "NTF" &&
                        loan?.loan_status !== "DONE" && (
                          <button
                            disabled={
                              loading || Number(amount) <= 0 || !filePayment
                            }
                            type="button"
                            className={classNames(
                              "flex items-center justify-center px-8 py-2 text-sm font-medium text-blue-900 border border-transparent rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500",
                              {
                                "cursor-pointer hover:bg-blue-200 bg-blue-100":
                                  !loading && Number(amount) > 0 && filePayment,
                                "cursor-not-allowed bg-gray-300":
                                  loading ||
                                  Number(amount) <= 0 ||
                                  !filePayment,
                              }
                            )}
                            onClick={onAction}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className={
                                (loading ? "" : "hidden") +
                                " animate-spin  h-6 w-6 mr-3"
                              }
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                              />
                            </svg>
                            อนุมัติ
                          </button>
                        )}
                    </div>
                  </Tab.Panel>
                  <Tab.Panel>
                    <div className="h-2"></div>
                    {/* <div className="w-full mb-4">
                      <div className="bg-black h-52 flex flex-col justify-center">
                        <FullScreen
                          className="w-full h-full"
                          handle={handleApprove}
                        >
                          {filePayment && (
                            <img
                              src={filePaymentBase}
                              onClick={handleApprove.enter}
                              className="w-full h-full object-contain bg-black"
                            />
                          )}
                        </FullScreen>
                      </div>
                      {!filePayment && (
                        <div className="text-red-500 text-xs mt-1">
                          โปรดอัพโหลดรูปภาพ
                        </div>
                      )}
                      <button
                        className={classNames(
                          "bg-blue-500 text-white px-2 py-1 rounded text-sm cursor-pointer mt-2"
                        )}
                        onClick={onClickOpenFile}
                      >
                        เลือกรูปภาพ
                      </button>
                    </div> */}
                    <CelesFloatingInputState
                      onChange={(e) => setAmountFee(e.target.value)}
                      label="ยอดเงิน"
                      disable={type === "demand_fee"}
                      value={amountFee}
                    />
                    <div className="h-2"></div>
                    <Dropdown
                      options={optionFee.filter(
                        (optionFee) => !optionFee?.disabled
                      )}
                      selected={type}
                      optionMap={optionMap}
                      label={"ประเภทค่าธรรมเนียม"}
                      setSelected={(value) => setType(value)}
                    />
                    <div className="h-2"></div>
                    <CelesFloatingInputState
                      onChange={(e) => setFeeRemark(e.target.value)}
                      label="หมายเหตุ"
                      value={feeRemark}
                    />

                    {type === "break_fee" && password !== confirmPassword && (
                      <React.Fragment>
                        <div className="h-2"></div>
                        <CelesFloatingInputState
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                          label="รหัสผ่าน"
                          value={password}
                          type="password"
                        />
                      </React.Fragment>
                    )}

                    {(type !== "break_fee" ||
                      (type === "break_fee" &&
                        password === confirmPassword)) && (
                      <div className="mt-4">
                        <button
                          disabled={loading || Number(amountFee) <= 0}
                          type="button"
                          className={classNames(
                            "flex items-center justify-center px-8 py-2 text-sm font-medium text-blue-900 border border-transparent rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500",
                            {
                              "cursor-pointer hover:bg-blue-200 bg-blue-100":
                                !loading && Number(amountFee) > 0,
                              "cursor-not-allowed bg-gray-300":
                                loading || Number(amountFee) <= 0,
                            }
                          )}
                          onClick={
                            !loading && Number(amountFee) > 0 && onActionFee
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className={
                              (loading ? "" : "hidden") +
                              " animate-spin  h-6 w-6 mr-3"
                            }
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                            />
                          </svg>
                          อนุมัติ
                        </button>
                      </div>
                    )}
                  </Tab.Panel>
                  <Tab.Panel>
                    <div className="h-2"></div>
                    <div className="w-full mb-4">
                      <div className="bg-black h-52 flex flex-col justify-center">
                        <FullScreen
                          className="w-full h-full"
                          handle={handleApprove}
                        >
                          {filePayment && (
                            <img
                              src={filePaymentBase}
                              onClick={handleApprove.enter}
                              className="w-full h-full object-contain bg-black"
                            />
                          )}
                        </FullScreen>
                      </div>
                      {!filePayment && (
                        <div className="text-red-500 text-xs mt-1">
                          โปรดอัพโหลดรูปภาพ
                        </div>
                      )}
                      <button
                        className={classNames(
                          "bg-blue-500 text-white px-2 py-1 rounded text-sm cursor-pointer mt-2"
                        )}
                        onClick={onClickOpenFile}
                      >
                        เลือกรูปภาพ
                      </button>
                    </div>
                    <CelesFloatingInputState
                      onChange={(e) => setServiceFee(e.target.value)}
                      label="ยอดเงิน"
                      value={serviceFee}
                    />
                    <div className="h-2"></div>
                    <CelesFloatingInputState
                      onChange={(e) => setFeeRemark(e.target.value)}
                      label="หมายเหตุ"
                      value={feeRemark}
                    />
                    <div className="h-2"></div>
                    <div className="flex flex-row w-full space-x-1 ">
                      <div className="w-24">
                        <Dropdown
                          options={optionsDates}
                          selected={pad(selectDate)}
                          label={"วัน"}
                          setSelected={onSelectDate}
                        />
                      </div>
                      <Dropdown
                        options={optionsMonths}
                        selected={pad(selectMonth)}
                        label={"เดือน"}
                        setSelected={onSelectMonth}
                      />
                      <Dropdown
                        options={optionsYears}
                        selected={pad(selectYear)}
                        label={"ปี"}
                        setSelected={onSelectYear}
                      />
                      <Dropdown
                        options={optionsHours}
                        selected={pad(selectHour)}
                        label={"ชั่วโมง"}
                        setSelected={onSelectHour}
                      />
                      <Dropdown
                        options={optionsMintues}
                        selected={pad(selectMinute)}
                        label={"นาที"}
                        setSelected={onSelectMintue}
                      />
                    </div>
                    <div className="mt-4">
                      <button
                        disabled={
                          loading || Number(serviceFee) <= 0 || !filePayment
                        }
                        type="button"
                        className={classNames(
                          "flex items-center justify-center px-8 py-2 text-sm font-medium text-blue-900 border border-transparent rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500",
                          {
                            "cursor-pointer hover:bg-blue-200 bg-blue-100":
                              !loading && Number(serviceFee) > 0 && filePayment,
                            "cursor-not-allowed bg-gray-300":
                              loading ||
                              Number(serviceFee) <= 0 ||
                              !filePayment,
                          }
                        )}
                        onClick={
                          !loading &&
                          Number(serviceFee) > 0 &&
                          onActionServiceFee
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={
                            (loading ? "" : "hidden") +
                            " animate-spin  h-6 w-6 mr-3"
                          }
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                          />
                        </svg>
                        อนุมัติ
                      </button>
                    </div>
                  </Tab.Panel>
                </Tab.Panels>
              </Tab.Group>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default PaymentModal;
